/*
 * @Author: liyxt
 * @Date: 2020-05-06 14:00:41
 * @LastEditors: liyxt
 * @LastEditTime: 2020-05-28 15:04:22
 * @Description: file content
 */ 
import React, { Component } from 'react';
import { Row as OriginRow } from 'bee-layout';
require('bee-layout/build/Layout.css');
export default class Row extends Component {
	render() {
		return <OriginRow {...this.props} />;
	}
}
